module.exports = __webpack_public_path__ + "static/img/t1-2.ca6eb3c.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/home/img/zh/t1-2.png
// module id = ojrV
// module chunks = 1